import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { useState } from "react";
import i18n from "../../../services/localization";
import styles from "./LangSwitcher.module.scss";
import { Modal } from "../../modal/Modal";
import { languages } from "./ProfilePopover";
import locale from "../../../constants/locale";

type Props = {
  open: boolean;
  onClose: () => void;
};

const LangSwitcher = ({ open, onClose }: Props) => {
  const { t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    languages.find((lang) => lang.code === i18n.language)?.code || "en"
  );

  const handleLanguageSelect = (langCode: string) => {
    setSelectedLanguage(langCode);
  };

  const handleSave = () => {
    i18n.changeLanguage(selectedLanguage);
    onClose();
  };

  return (
    <>
      <Modal
        isOpen={open}
        title={t(locale.chooseLanguage)}
        onClose={() => {
          onClose();
        }}
        primaryText={t(locale.save)}
        secondaryText={t(locale.cancel)}
        onPrimary={handleSave}
        onSecondary={onClose}
      >
        <div className={styles.langSwitcher}>
          <div className={styles.languageOptions}>
            {languages.map((language) => (
              <div
                key={language.code}
                className={clsx(
                  styles.languageOption,
                  "has-border my-2 has-rounded-corners p-3",
                  {
                    [styles.isSelected]: language.code === selectedLanguage,
                  }
                )}
                onClick={() => handleLanguageSelect(language.code)}
              >
                <span className={`${styles.flagIcon} mx-2`}>
                  {language.flag}
                </span>
                <span className="subtitle is-6 has-text-weight-medium">
                  {language.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default observer(LangSwitcher);
